import React, { useEffect, useState } from 'react';
import { Button, Card, Snackbar, Typography, Stack } from '@mui/joy';

const UpdateNotification=()=> {
  const [waitingWorker, setWaitingWorker] = useState(null);
  const [showRefresh, setShowRefresh] = useState(false);

  const handleClose = () => {
    setShowRefresh(false)
  }

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      // Register the service worker
      //console.log({navigator})
      console.log('sw in navigator')
      navigator.serviceWorker.register('../../service-worker.js').then(registration => {
        if (!navigator.serviceWorker.controller) {
            console.log('no sw in navigator')
          return;
        }
        
        registration.update();
        
        onNewServiceWorker(registration, () => {
          setWaitingWorker(registration.waiting);
          console.log('should show refresh now')
          setShowRefresh(true);
        });

        let refreshing;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (refreshing) return;
          refreshing = true;
          console.log('reloading page')
          window.location.reload();
        });
      });
    }
  }, []);

  const onNewServiceWorker = (registration, callback) => {
    console.log('about to check if sw waiting')
    if (registration.waiting) {
        console.log('sw is waiting')
      return callback();
    } else {
        console.log('sw not waiting')
    }

    const listenInstalledStateChange = () => {
      registration.installing.addEventListener('statechange', (event) => {
        if (event.target.state === 'installed') {
            console.log('sw state installed')
          callback();
        }
      });
    };

    if (registration.installing) {
        console.log('registration installing')
      listenInstalledStateChange();
    }

    registration.addEventListener('updatefound', listenInstalledStateChange);
  };

  const handleRefreshClick = () => {
    if (waitingWorker) {
        console.log('posting skipwaiting')
      waitingWorker.postMessage('skipWaiting');
    }
  };

  return (
    <>
      {showRefresh && (
        <Snackbar
  open={showRefresh}
  // Removed onClose={handleClose}
  color='warning'
  variant='soft'
  anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
  autoHideDuration={null} // keeps it open
  disableCloseOnClickAway // disables clicking outside to close (Joy UI accepts this)
  disableEscapeKeyDown // disables Esc key to close
  sx={{
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    mb: '20px',
    mr: '20px',
    borderRadius: '5px',
    borderWidth: '2px',
    borderColor: 'grey',
    borderStyle: 'solid'
  }}
>
  <Stack direction={'row'} alignItems='center' spacing={1}>
    <Typography fontSize='18px' fontWeight='bold' fontFamily="Bai Jamjuree">
      Update Available. Please update
    </Typography>
    <Button
      color='success'
      variant='plain'
      borderRadius='50px'
      onClick={handleRefreshClick}
    >
      <Typography fontSize='18px' fontWeight='bold' fontFamily="Bai Jamjuree" color='success'>
        UPDATE
      </Typography>
    </Button>
  </Stack>
</Snackbar>

      )}
    </>
  );
}



export default UpdateNotification;
